module.exports = __webpack_public_path__ + "img/equityStructureBase.b79f4bd6.png";